import { Injectable } from '@angular/core';

import { CredentialsStore } from '@jts-shared/auth';

export type { Credentials } from '@jts-shared/auth';

@Injectable({
  providedIn: 'root',
})
export class CredentialsService extends CredentialsStore {}
